import tailwindConfig from 'tailwind.config';

import { BlockReferenceArray } from '@/cms/types/block';

import { HeaderStrapiProps } from '@/decodo/features/Header/transformer';
import { apiCallStrapi } from '@/utils/fetch';

export const HEADER_LG_MEDIA_QUERY = `(max-width: ${
  parseInt(tailwindConfig.theme.screens.headerLg) - 1
}px)`;

export const fetchHeaderData = (documentId: string) =>
  apiCallStrapi<BlockReferenceArray<HeaderStrapiProps>>({
    path: `/headers`,
    query: {
      pLevel: 'deep',
      filters: {
        documentId: documentId,
      },
    },
    method: 'GET',
    next: {
      revalidate: 10 * 60,
      tags: [`header-document-id-${documentId}`],
    },
  });
